<template>
  <section style="width: 100%;height: 100%;background: #fff;position: fixed;min-height: 500px;">

    <router-link to="/" style="position: absolute;top:5%;right: 10%">
      <div  style="width: 108px;height: 34px;line-height: 34px;text-align: center;background: rgb(255, 168, 37);border: 1px solid rgb(255, 168, 37);
    color: #fff;font-size: 14px;font-weight: 600;cursor: pointer;">回到首页</div></router-link>

    <img src="@/assets/images/login-bg1.jpg" alt="" style="width: 100vw;height: 100vh;object-fit: cover;border: 0;position: fixed;top: 0;left: 0;z-index: -1">

   <!-- 修改容器样式，实现完美的水平和垂直居中 -->
   <div style="display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    ">
     <div style="text-align: center;margin-bottom: 30px;">
       <h1 style="font-size: 32px;
        color: rgb(255 168 35);
        display: block;
        margin: 0;
        text-shadow: rgb(0 0 0) 0px 0px 10px, rgb(7 6 3) 0px 0px 20px, rgb(139 138 133) 0px 0px 30px, rgb(73 84 61) 0px 0px 40px;
        font-weight: bold;">特资信大模型·特殊资产价值智评系统</h1>
     </div>

     <div style="height: 420px;
    background: #fff;
    box-shadow: 0 0 15px rgba(0,0,0,0.15);
    border-radius: 8px;">
       <div style="width: 480px;
    height: 420px;
    background: #fff;
    padding: 40px 60px 0;
    cursor: pointer;">
         <div>
           <div style="font-size: 24px;
    font-weight: 500;
    color: #333;
    margin-bottom: 30px;text-align: center;">用户登录</div>

           <a-form :form="form"  @submit="handleSubmit">
             <a-form-item>
               <a-input
                   v-decorator="['uccode', { rules: [{ required: true, message: '请输入您的用户名！' }] }]"
                   placeholder="请输入您的用户名"
                   size="large"
                   z-index="10000"
                   type="text">
                 <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
               </a-input>

             </a-form-item>

             <a-form-item>
               <a-input-password v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] }]"
                                 placeholder="请输入密码"
                                 size="large"
                                 z-index="10000"
                                 type="text"
               >
               <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
               </a-input-password>
             </a-form-item>

             <a-form-item>
               <a-input
                   v-decorator="['inputCode',{ rules: [{ required: true, message: '请输入图形验证码' }] }]"
                   size="large"
                   type="text"
                   style="width: 250px;"
                   @change="inputCodeChange"
                   placeholder="请输入验证码">
                 <a-icon slot="prefix" type="safety-certificate" :style="{ color: 'rgba(0,0,0,.25)' }"/>
               </a-input>
               <img v-if="requestCodeSuccess" style="margin-top: 2px;z-index: 9999" :src="randCodeImage" @click="handleChangeCheckCode" />
               <img v-else style="margin-top: 2px;z-index: 9999" src="../../assets/checkcode.png" @click="handleChangeCheckCode"/>
             </a-form-item>

             <a-form-item>
               <a-button style="background: rgb(255, 168, 37);border: rgb(255, 168, 37);margin: 14px 0;
    width: 320px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 3px;
    color: #fff;" type="primary" html-type="submit">
                 登 录
               </a-button>

             </a-form-item>
             <div style="font-size: 12px;">

               <span> 还没注册?</span><router-link to="/register"><span style="color: #034fa2;display: inline-block;margin-left: 2px;">立即注册</span></router-link>
             </div>
           </a-form>

         </div>
       </div>
     </div>
   </div>

    <footer style="height: 44px;background: #666;position: absolute;bottom: 0;z-index: 9999;width: 100%">
      <div style="    height: 100%;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
    color: #fff;
width: 1200px;
    margin: 0 auto;">
<!--        <ul style="    display: -webkit-box;-->
<!--    display: -ms-flexbox;-->
<!--    display: flex;-->
<!--    -webkit-box-align: center;-->
<!--    -ms-flex-align: center;-->
<!--    align-items: center;-->
<!--    margin-right: 70px;-->
<!--    margin-bottom: 0em;">-->
<!--          <li>-->
<!--            <router-link to="/legaldec" >-->
<!--              <span  style="cursor: pointer;text-decoration: none;color:rgb(255 255 255);"> 法律声明 </span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li style="width: 1px;height: 10px;background: #fff; margin: 0 12px;"></li>-->
<!--          <li>-->
<!--            <router-link to="/contact">-->
<!--              <span style="cursor: pointer;text-decoration: none;color: rgb(255 255 255);"> 联系我们 </span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li style="width: 1px;height: 10px;background: #fff; margin: 0 12px;"></li>-->
<!--          <li>-->
<!--            <router-link to="/about">-->
<!--              <span style="cursor: pointer;text-decoration: none;color: rgb(255 255 255);"> 平台介绍 </span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--        </ul>-->
        <span style="-webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;">©2026 特资信大模型·特殊资产价值智评系统
<!--          <a href="https://beian.miit.gov.cn/" style="color: #FFFFFF" target="_blank"> 粤ICP备2023133949号 </a>-->
        </span>
      </div>
    </footer>
  </section>


</template>

<script>
import {mapActions} from "vuex"
import {getAction} from "@/api/manage";

export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      inputCodeContent: '',
      requestCodeSuccess: false,
      randCodeImage: '',
      currdatetime: '',
    };
  },
  created() {
    this.currdatetime = new Date().getTime();
    this.handleChangeCheckCode();
  },
  methods: {
    ...mapActions(["Login"]),
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value
    },
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime();
      getAction(`/user/randomImage/${this.currdatetime}`).then(res => {
        if (res.success) {
          this.randCodeImage = res.data.imgCode;
          this.requestCodeSuccess = true
        } else {
          this.$message.error(res.message)
          this.requestCodeSuccess = false
        }
      }).catch(() => {
        this.requestCodeSuccess = false
      })
    },
    handleSubmit(e) {
      let that = this;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let loginParams = {};
          loginParams.uccode = values.uccode;
          loginParams.password = values.password;
          loginParams.inputCode = values.inputCode;
          loginParams.checkKey = this.currdatetime
          that.Login(loginParams).then((res) => {
            if (res.code == 200) {
              this.$message.success('登录成功')
              this.$router.push('/')
            } else {
              this.$message.error(res.message)
            }
          });
        }
      });
    },
  },
};
</script>
